import React from 'react';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import ExcludedTpJobPayEvaluatorsSearchParams from './ExcludedTpJobPayEvaluatorsSearchParams';
import TpJobService from '../../../../Services/TpJobService';
import ExcludedTpJobTpEvaluatorItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ExcludedTpJobTpEvaluatorItem';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';

export default class ExcludedTpJobPayEvaluatorsAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchItem: new ExcludedTpJobPayEvaluatorsSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
    };

    this.startSearch = this.startSearch.bind(this);
    this.renderActionButtons = this.renderActionButtons.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  getAllItemsInTheSearchAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSelectedCount() {
    if (this.getAllItemsInTheSearchAreSelected()) {
      return this.state.numberOfElementsInTheTable;
    }
    return this.state.itemList.filter((u) => u.Selected === true).length;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  getSearchParameters() {
    return {
      ...this.state.searchItem,
      Projectid: this.props.ProjectId,
      AssignmentType: this.props.type,
    };
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  clickOnOkGeneratePayment() {
    ErrorMessage.SetNotification(
      'The assignment payment generation process is running in the background. You will receive a message about the result as soon as it has been finished. '
    );
    ThirdPartyJobPaymentsService.GenerateAssignmentPayment(
      [...this.getSelected().map((s) => s.TpJobId)],
      this.getSearchParameters(),
      this.state.allItemsInTheSearchSetAreSelected
    )
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        }
        this.refresh();
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: EPEA56');
      });
  }

  clickOnGenerateAssignmentPayment() {
    ErrorMessage.SetApprove(
      `You are about to generate assignment payment for ${this.getSelectedCount()} assignment(s).`,
      this.clickOnOkGeneratePayment.bind(this)
    );
  }

  renderActionButtons() {
    // CD-5658: the server refuses these jobs too, including those selected through "select all".
    const hasApolloPaidShop = this.getSelected().some((item) => item.IsShopperPaidThroughApollo === true);
    const disabled = !this.state.itemList.find((il) => il.Selected) || hasApolloPaidShop;
    return (
      <FigmaButtonRow
        buttons={[
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () => this.clickOnGenerateAssignmentPayment(),
            tooltip: hasApolloPaidShop
              ? 'Prism shops in China, Hong Kong, Macau and Taiwan are paid from the Apollo shop: unselect them to generate assignment payments'
              : 'Generate Assignment Payment',
            roleKey: 'EvaluatorPayment_GenerateAssignmentPayment_FigmaButtonRowButton',
            disabled,
          },
        ]}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderActionButtons()}
        <TabOfDataTable
          type={ExcludedTpJobTpEvaluatorItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={TpJobService.GetAllItemsBySearching}
          convertDBItemsFunction={TpJobService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='CaspianClientDetails'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={ExcludedTpJobPayEvaluatorsSearchParams}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Clients, FW Offices, Statuses, Sources or Job IDs...'
        />
      </div>
    );
  }
}
